import React from 'react'
import styles from './groups-head.styles'
import injectSheet from 'react-jss'
import Button from 'pobble-components/dist/button'

const GroupsHead = ({ classes, onAddGroup, showingSelected, showAll }) => (
  <div className={classes.container}>
    {showingSelected && (
      <span className={classes.showingSelected}>
        You are seeing only selected groups.{' '}
        <span className={classes.showAll} onClick={showAll}>
          Show all
        </span>
      </span>
    )}
    <Button
      disabled={showingSelected}
      tall
      className={classes.addGroupButton}
      action={onAddGroup}>
      Add a group
    </Button>
  </div>
)

export default injectSheet(styles)(GroupsHead)
